import React, { useState } from "react";
import Societies from "../../component/Societies/Societies";
import banner from "../../asset/illegal banner.png";
import { useGetIllegalSocietiesQuery } from "../../Redux/getApi";
import { useDebounce } from "use-debounce";

const UnauthorizedSocieties = () => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [debouncedSearch] = useDebounce(search, 1500);

  const { data, error, isLoading, isFetching } = useGetIllegalSocietiesQuery({
    page,
    search: debouncedSearch,
  });
  const illegalSocieties = data?.societies;
  const totalPages = data?.totalPages;
  const currentPage = data?.currentPage;
  return (
    <div>
      <Societies
        societies={illegalSocieties}
        bgColor="#F1D1CE"
        color="#D80000"
        banner={banner}
        name="Illegal Housing Societies"
        error={error}
        isLoading={isLoading}
        isFetching={isFetching}
        totalPages={totalPages}
        currentPage={currentPage}
        search={search}
        setSearch={setSearch}
        page={page}
        setPage={setPage}
        societyStatus="illegal"
      />
    </div>
  );
};

export default UnauthorizedSocieties;
